export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div id="${this.ids.id}" class="${this.classes.classes}">
      ${this.content.text}
    </div>`
  }
}